// pages/VendorOnboardingPage.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import VendorOnboarding from '../components/vendor/VendorOnboarding';

const VendorOnboardingPage = () => {
  const navigate = useNavigate();

  const handleClose = () => {
    navigate('/vendors');
  };

  const handleSuccess = (vendorData) => {
    navigate('/vendor/dashboard');
  };

  return (
    <div className="min-h-screen bg-gray-100 py-8">
      <div className="max-w-4xl mx-auto">
        <VendorOnboarding
          isOpen={true}
          onClose={handleClose}
          onSuccess={handleSuccess}
        />
      </div>
    </div>
  );
};

export default VendorOnboardingPage;